import { render, staticRenderFns } from "./ArticleList2.vue?vue&type=template&id=4782962a&scoped=true"
import script from "./ArticleList2.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleList2.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ArticleList2.vue?vue&type=style&index=0&id=4782962a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4782962a",
  null
  
)

export default component.exports